export const PRIMARY_COLOR = "#006996";

export const theme = {
  token: {
    colorPrimary: PRIMARY_COLOR,
    colorLink: PRIMARY_COLOR,
    colorLinkHover: "#1a7fa3",
    borderRadius: 2,
    colorBgLayout: "#f0f2f5",
    fontFamily: "Titillium Web",
  },
};
